import { fetchWaveformData } from '../services/waveform'
import {} from '@trpc/client'



import { useState, useRef, useEffect } from 'react';
export interface UseWaveformOptions {
  url?: string | null
}

export function useWaveform(options: UseWaveformOptions = {}) {
  const { url } = options

  const [internalPeaks, setInternalPeaks] = useState<number[][] | null>(null)
  const fetchedUrlRef = useRef<string | null>(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (url && url !== fetchedUrlRef.current) {
      fetchedUrlRef.current = url
      setLoading(true)
      fetchWaveformData(url)
        .then((data) => {
          if (fetchedUrlRef.current === url) {
            setInternalPeaks(data)
          }
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.debug(err)
        })
        .finally(() => {
          setLoading(false)
        })
    }
  }, [url])

  return {
    data: internalPeaks,
    loading,
  }
}
